import app from 'app';

app.namespace.Model.ProgrammerModel = Backbone.Model.extend({
  idAttribute: 'id',

  defaults: function () {
    return {
      configInitialOverlayImageDT: 3,
    };
  },

  parse: function (raw) {
    if (!_.isDefined(raw.maxStoryDuration)) {
      raw.maxStoryDuration = app.TIME.MAX_STORY_DURATION;
    }

    return raw;
  },

  getOrganization: function () {
    return _.find(tk.context.organizations, (tmpOrg) =>
      tmpOrg.programmerIds.includes(this.get('id'))
    );
  },
});
